import { NavLink } from "react-router-dom";
import useLabels from "../../hooks/useLabels";
import SecondaryBar from "../SecondaryBar";
import { CTA, InfoCard } from "../Generic";
// import LotList from "../LotList";
import useAuth from "../../hooks/useAuth";
import { ROLES } from "../../constants/base";
import { selectActiveWinery, selectLots } from "../../context/selectors";
import { useDispatch, useSelector } from "react-redux";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLots } from "../../services/utils";
import { setLots } from "../../context/lots/lotsSlice";
import { lazy, Suspense, useEffect, useState } from "react";
import grape from "../../assets/icons/grape.png";
import bottled from "../../assets/icons/wine-bottles.png";
import closed from "../../assets/icons/wine-bottles.png";
import must from "../../assets/icons/must.png";
import wine from "../../assets/icons/wine.png";
import barrel from "../../assets/icons/tonneau.png";

import "./styles/index.scss";
import { SkeletonInfoCard, SkeletonTableEdit } from "../Skeleton/Skeleton";
import { Icon } from "../../components/Icon";

const LotList = lazy(() => import("../LotList"));
// const InfoCard = lazy(() => import("../Generic"));

const Lots = ({ isMobile }) => {
  const activeWinery = useSelector(selectActiveWinery);
  const [getLabel] = useLabels();
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const lots = useSelector(selectLots);
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate();
  const [lotsLen, setLotsLen] = useState({});

  const STATES = {
    wine: { state: "WINE" },
    must: { state: "MUST" },
    grape: { state: "GRAPE" },
    bottled: { state: "BOTTLED", status: "CONFIRMED" },
    closed: { state: "CLOSED" },
    aging: { state: "CLOSED" }, // same condition as closed?    // TO DO
  };

  const COLORS = ["RED", "WHITE", "ROSE", "ORANGE"];

  const loadLots = async () => {
    const currentLots = await getLots(activeWinery.id, axiosPrivate);
    dispatch(setLots(currentLots));
  };

  useEffect(() => {
    if (!lots || lots?.length === 0) {
      loadLots();
    }
  }, []);

  useEffect(() => {
    if (!lots || lots.length === 0) return;
    
    const matches = (lot, rule) => {
      if (rule.state && lot.state !== rule.state) return false;
      if (rule.status && lot.status !== rule.status) return false;
      return true;
    };

    const tmp = {
      tot: lots.length,
    };

    // Step 1: compute base counts
    for (const key in STATES) {
      const rule = STATES[key];
      tmp[key] = lots.filter((l) => matches(l, rule)).length;
    }

    // Step 2: compute color breakdowns
    for (const key in STATES) {
      const rule = STATES[key];
      const filtered = lots.filter((l) => matches(l, rule));

      tmp[key + "s"] = COLORS.reduce((acc, color) => {
        acc[color.toLowerCase()] = filtered.filter((l) => l.color === color).length;
        return acc;
      }, {});
    }

    setLotsLen(tmp);
  }, [lots]);

  const getTooltipContent = (obj = {}) => {
    return (
      <ul>
        {Object.keys(obj)?.map((o, i) => (
          <li key={`lot_tooltip_${i}`} className="tooltip_label">{`${getLabel(
            `lotColor_${o?.toUpperCase()}`
          )}: ${obj?.[o]}`}</li>
        ))}
      </ul>
    );
  };

  const renderNavMenu = () => {
    return (
      <div className="primary_container_menu">
        <h2>{getLabel("lots")}</h2>
        <div>
          <h5 className="tanks_title">
            {getLabel("numTotLots")}
            <span className="tanks_span">{lotsLen?.tot || "0"}</span>
          </h5>
        </div>
        <div className="tanks_wrapper">
          {[ROLES.CLIENT, ROLES.TANK].includes(role) && (
            <NavLink to="/lots/new" className="cta_wrapper">
              <CTA customClassName={"create"}>
                {getLabel("createLot")} <Icon icon="fa-plus" />
              </CTA>
            </NavLink>
          )}
          <div className="tanks_recap">
            <div className="tanks_recap_wrapper">
              <Suspense fallback={<SkeletonInfoCard />}>
                <InfoCard
                  label={getLabel("numTotGrapeLots")}
                  number={lotsLen?.grape}
                  img={isMobile || true ? grape : null}
                  isGrey={lotsLen?.grape === 0}
                  content={getTooltipContent(lotsLen?.grapes)}
                />
                <InfoCard
                  label={getLabel("numTotMustLots")}
                  number={lotsLen?.must}
                  img={isMobile || true ? must : null}
                  isGrey={lotsLen?.must === 0}
                  content={getTooltipContent(lotsLen?.musts)}
                />
                <InfoCard
                  label={getLabel("numTotWineLots")}
                  number={lotsLen?.wine}
                  img={isMobile || true ? wine : null}
                  isGrey={lotsLen?.wine === 0}
                  content={getTooltipContent(lotsLen?.wines)}
                />
                <InfoCard
                  label={getLabel("numTotBottledLots")}
                  number={lotsLen?.bottled}
                  img={isMobile || true ? bottled : null}
                  isGrey={lotsLen?.bottled === 0}
                  content={getTooltipContent(lotsLen?.bottleds)}
                />
                <InfoCard
                  label={getLabel("numTotAgingLots")}
                  number={lotsLen?.aging}
                  img={isMobile || true ? barrel : null}
                  isGrey={lotsLen?.aging === 0}
                  content={getTooltipContent(lotsLen?.agings)}
                />
                <InfoCard
                  label={getLabel("numTotClosedLots")}
                  number={lotsLen?.closed}
                  img={isMobile || true ? closed : null}
                  isGrey={lotsLen?.closed === 0}
                  content={getTooltipContent(lotsLen?.closeds)}
                />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="primary_container">
      <SecondaryBar breadCrumb={[getLabel("lotsNavLink")]} />
      {renderNavMenu()}
      <div className="lots_content_wrapper">
        {/* <div className="lots_sidebar_left">
          {[ROLES.CLIENT, ROLES.TANK].includes(role) && (
            <NavLink to="/lots/new" className="cta_wrapper">
              <CTA customClassName={"create"}>
                {getLabel("createLot")} <Icon icon="fa-plus" />
              </CTA>
            </NavLink>
          )}
        </div> */}
        <div className="lots_content_right">
          <Suspense fallback={<SkeletonTableEdit colCount={6} isMobile={isMobile} />}>
            <LotList isMobile={isMobile} />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default Lots;
